'use client'

import { FC } from 'react'
import { Onboarding } from './Onboarding'
import { useOnboardingState } from '@/hooks/useOnboardingState'

export const OnboardingContainer: FC = () => {
  const { isVisible, hide } = useOnboardingState()

  return isVisible ? <Onboarding onClose={hide} /> : null
}
